import { Faq } from '@/types/common'

export const faqs: Faq[] = [
  {
    question: 'サイズの寸法を教えてください',
    answer:
      `メーカーの基準により、サイズ寸法は異なります。<br>
      各商品のサイズ寸法については、商品情報のサイズ一覧表をご参照ください。<br>
      <img src="https://guide.raksul.com/hc/article_attachments/7327067792655" loading="lazy">`
  },
  {
    question: '欠品中の場合、次回入荷はいつですか？',
    answer:
      `ご希望の商品ページにてご確認ください。<br>
      次回入荷予定が決まっているものについては、サイズ入力欄の下に記載がございます。<br>
      <img src="https://guide.raksul.com/hc/article_attachments/6982526970767" loading="lazy">`
  },
  {
    question: '本体色違いで注文をする場合の方法を教えてください',
    answer:
      `本体色1カラーごとにサイズ入力や印刷方法など仕様をご選択のうえ、<br>
      デザイン編集をしていただき、カートに追加してください。<br>
      全てをカートに追加後に注文手続き画面をお進みください。<br>
      <strong>※同時に複数の本体色をカートに追加いただくことはできません。</strong>`
  },
  {
    question: '印刷可能範囲を教えてください',
    answer:
      `ご希望の商品ページにて仕様を選択のうえ、「デザイン編集画面」にてご確認いただけます。<br>
      <strong>①各仕様を選択のうえ、「デザイン編集をしてカートへ入れる」をクリックします。</strong><br>
      <img src="https://guide.raksul.com/hc/article_attachments/6941718838415" loading="lazy"><br>
      <strong>②デザイン編集画面上の右下に印刷範囲の記載がございます。</strong><br>
      <img src="https://guide.raksul.com/hc/article_attachments/6941758287503" loading="lazy">`
  },
  {
    question: '見積りの算出方法を教えてください',
    answer:
      `サイト上で見積りの算出が可能です。<br>
      ご希望の商品ページにて「数量・印刷方法・印刷箇所」をご選択いただければ<br>
      見積りと最短出荷日が表示されます。<br>
      ※見積書の発行方法は<a href="https://guide.raksul.com/hc/ja/articles/4447312526863" target="_blank" rel="noopener">こちら</a>もご参照ください。`
  }
]
